module.exports = __webpack_public_path__ + "img/Hepatology202206_incert.bfb26efb.jpg";